import { defineStore } from 'pinia'
import api from '../services/api'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    token: localStorage.getItem('auth_token') || null,
    isPremium: false
  }),
  
  actions: {
    async forgotPassword(email) {
      try {
        const response = await api.post('/forgot-password', { email })
        return { success: true, message: response.data.message || 'Correo enviado' }
      } catch (error) {
        return { 
          success: false, 
          message: error.response?.data?.message || 'Error al enviar el correo' 
        }
      }
    },
    
    logout() {
      this.token = null
      this.user = null
      this.isPremium = false
      localStorage.removeItem('auth_token')
      localStorage.removeItem('user')
    }
  }
})